import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { LevelForm } from "../LevelForm";
import { EditLevelModalProps } from "./types";
import { useEditLevelModal } from "./controller";

export const EditLevelModal = React.memo(({ modalRef, onComplete }: EditLevelModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditLevelModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("level_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <LevelForm />
    </Modal>
  );
});
